import './agenda-available-appointment-slot-list-item.scss';

import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import {
  AgendaAvailableSlotItemDataFragment,
  ConsultType,
} from '../../../data/types/api/graphql';
import { formatDateTimeToTime } from '../../../data/utils/date.utils';
import { makeKeyDownHandler } from '../../../data/utils/make-key-down-handler';

type AgendaAvailableAppointmentSlotListItemProps = {
  agendaSlotItem: AgendaAvailableSlotItemDataFragment;
  consultType: ConsultType;
  active?: boolean;
  highlight?: boolean;
  compact?: boolean;
  showAsRange?: boolean;
  onClick?: (value: AgendaAvailableSlotItemDataFragment) => void;
};

export function AgendaAvailableAppointmentSlotListItem({
  agendaSlotItem,
  active,
  highlight,
  compact,
  consultType,
  showAsRange,
  onClick,
}: AgendaAvailableAppointmentSlotListItemProps) {
  const intl = useIntl();

  const attributes = useMemo(() => {
    if (onClick) {
      return {
        role: 'button',
        tabIndex: 0,
        onClick: () => onClick(agendaSlotItem),
        onKeyDown: makeKeyDownHandler(() => onClick(agendaSlotItem)),
      };
    }

    return {};
  }, [agendaSlotItem, onClick]);

  return (
    <div
      {...attributes}
      className={`appointment-available-slot-list-item${
        active ? ' active' : ''
      }${highlight ? ' highlight' : ''}${compact ? ' compact' : ''}${
        consultType === ConsultType.Visit && agendaSlotItem.existing === true
          ? ' existing'
          : ''
      }`}
    >
      <div className="appointment-available-slot-list-item__content">
        {showAsRange === true
          ? `${formatDateTimeToTime(
              agendaSlotItem.startTime,
              intl
            )} - ${formatDateTimeToTime(agendaSlotItem.endTime, intl)}`
          : `${formatDateTimeToTime(agendaSlotItem.startTime, intl)}`}
      </div>
    </div>
  );
}
